export default {"src":"/_next/static/media/backgroundImageExample.f220b564.svg","height":353,"width":1120,"blurWidth":0,"blurHeight":0};